export const LOCAL_STORAGE_KEYS = {
  TABLE_STATE: "table_state", // used to save initial table state for each user, see apps\viniti\src\hooks\tableCache.ts
  TABLE_FILTERS: "table_filters", // used to save table filters for each user
} as const;

export const CAPTURE_ROLES = {
  ADMIN: 0,
} as const;

export const DASHBOARD_TAG_TYPE_ID = 3 as const;
